import styled from 'styled-components';
import { maxWidth, MEDIA } from '../../styles';

import { PANEL_HEADER_HEIGHT } from '../../styles/dimensions';

import { Flex, HStack, Stack } from '../Core';

export const Panel = styled(Stack)`
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export const PanelHeader = styled(HStack)`
  background: var(--colors-gray-main);
  justify-content: space-between;
  white-space: nowrap;
  margin-bottom: 0;
  width: 100%;

  min-height: ${({ minHeight }) => minHeight};

  gap: ${({ theme }) => theme.spacing12}px;

  flex: 0 0 auto;
  ${maxWidth(MEDIA.medium)} {
    gap: ${({ theme }) => theme.spacing4}px;
  }

  h2 {
    margin: 0;
    margin-right: auto;
    font-size: ${({ theme }) => theme.fontSizeBig}rem;
  }
`;

PanelHeader.defaultProps = {
  alignItems: 'flex-end',
  p: 'spacing24',
  minHeight: `${PANEL_HEADER_HEIGHT}px`,
};

export const PanelActions = styled(HStack)`
  gap: ${({ theme }) => theme.spacing8}px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const PanelContent = styled(Flex)`
  position: relative;
  overflow-y: auto;
`;
PanelContent.defaultProps = {
  flexDirection: 'column',
  background: 'backgroundContent',
  h: '100%',
  w: '100%',
  px: 'spacing24',
  pt: 0,
  pb: 'spacing24',
};

export const PanelHeaderStrip = styled(HStack)`
  background: var(--talos-colors-gray-main);
  height: 40px;
  width: 100%;
  margin-bottom: 0;
  flex: 0 0 auto;
`;
PanelHeaderStrip.defaultProps = {
  px: 'spacing24',
  color: 'colors.gray.090',
  fontSize: 'fontSizeSmall',
};
